import axiosClient from "config/axiosClient"

const client: any = axiosClient("OSRM").getClient()

export const request_post = async (url: any, request: any, cancel_token: any) => {
  const headers = { headers: { "Content-Type": "application/json" }, cancel_token }

  return await client.post(url, request, headers)
}
